import Image from 'next/image'
import PropTypes from 'prop-types'

import { constants } from '../../../lib/constants'
import styles from './vehicle-condition-badge.module.scss'

export const VehicleConditionBadge = ({
  isElectric = false,
  size = 'xs',
  label = 'New',
  hasCommaAfter = false,
}) => {
  if (isElectric) {
    return (
      <p className={`${styles.badge} ${styles.electric} ${styles[size]}`}>
        <Image
          src={`${constants.imageHost.assets}/icons/library/zap-electric.svg`}
          height={14}
          width={14}
          alt="Electric zap icon"
        />{' '}
        Electric
        {hasCommaAfter && ','}
      </p>
    )
  }

  return (
    <p className={`${styles.badge} ${styles.new} ${styles[size]}`}>
      {label}
      {hasCommaAfter && ','}
    </p>
  )
}

VehicleConditionBadge.propTypes = {
  isElectric: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  label: PropTypes.string,
}
